<script setup lang="ts">
import AppShell from './modules/common/components/AppShell.vue'
import { useSession } from './auth/session.js'

const session = useSession()
</script>

<template>
  <!-- The shell owns navigation and the user menu, so the login and 404 views
       render bare rather than inside a chrome that implies a session. -->
  <AppShell v-if="session.isAuthenticated">
    <RouterView />
  </AppShell>
  <RouterView v-else />
</template>
